import { useState } from "react";

export function BulkActionsToolbar({ count, onClear, onBulkStatus, onBulkReschedule }) {
  const [rescheduleOpen, setRescheduleOpen] = useState(false);
  const [rescheduleDate, setRescheduleDate] = useState("");
  return (
    <div
      className="fixed bottom-4 left-1/2 -translate-x-1/2 z-40 rounded-2xl bg-[#2C302E] text-white shadow-2xl px-4 py-3 flex items-center gap-3 flex-wrap"
      data-testid="bulk-actions-toolbar"
    >
      <span className="text-sm font-medium" data-testid="bulk-actions-count">{count} selected</span>
      <div className="flex items-center gap-1">
        <button className="text-xs px-3 py-1.5 rounded-full bg-[#3B5B3E] hover:bg-[#2F4A33]" onClick={() => onBulkStatus("paid")} data-testid="bulk-mark-paid">Mark Paid</button>
        <button className="text-xs px-3 py-1.5 rounded-full bg-[#8C5D30] hover:bg-[#734A26]" onClick={() => onBulkStatus("pending")} data-testid="bulk-mark-pending">Mark Pending</button>
        <button className="text-xs px-3 py-1.5 rounded-full bg-[#59605C] hover:bg-[#3F4442]" onClick={() => onBulkStatus("unpaid")} data-testid="bulk-mark-unpaid">Mark Unpaid</button>
        {rescheduleOpen ? (
          <div className="flex items-center gap-1 pl-2 border-l border-white/20">
            <input
              type="date"
              value={rescheduleDate}
              onChange={(e) => setRescheduleDate(e.target.value)}
              className="text-xs px-2 py-1 rounded-md text-[#2C302E]"
              data-testid="bulk-reschedule-date"
            />
            <button
              className="text-xs px-3 py-1.5 rounded-full bg-[#4A6148] hover:bg-[#3B4F3A] disabled:opacity-50"
              disabled={!rescheduleDate}
              onClick={() => { onBulkReschedule(rescheduleDate); setRescheduleOpen(false); setRescheduleDate(""); }}
              data-testid="bulk-reschedule-apply"
            >
              Apply
            </button>
          </div>
        ) : (
          <button className="text-xs px-3 py-1.5 rounded-full bg-[#4A6148] hover:bg-[#3B4F3A]" onClick={() => setRescheduleOpen(true)} data-testid="bulk-reschedule-open">
            Reschedule all…
          </button>
        )}
      </div>
      <button className="text-xs text-white/70 hover:text-white ml-1" onClick={onClear} data-testid="bulk-clear">Clear</button>
    </div>
  );
}
